var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"editor",staticStyle:{"text-align":"left","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }